import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import pageTitle from 'ember-page-title/helpers/page-title';
import PartnerDashboardPage from 'tio-employee/components/partner-dashboard/page';
import type { PartnerDashboardModel } from 'tio-employee/routes/authenticated/admin/index';

interface AdminIndexSignature {
  Args: {
    /** Present only when the beta partner dashboard applies; the route redirects otherwise. */
    model: PartnerDashboardModel | undefined;
  };
}

const AdminIndexTemplate: TOC<AdminIndexSignature> = <template>
  {{#if @model}}
    {{pageTitle (t "partner_dashboard.title")}}
    <PartnerDashboardPage @model={{@model}} />
  {{/if}}
</template>;

export default AdminIndexTemplate;
